import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

interface StatusBadgeProps {
  status: "ok" | "success" | "warning" | "error" | "pending" | "running"
  label?: string
  animated?: boolean
  className?: string
}

const statusConfig = {
  ok: { variant: "default" as const, label: "OK", color: "bg-green-500" },
  success: {
    variant: "default" as const,
    label: "Success",
    color: "bg-green-500",
  },
  warning: {
    variant: "secondary" as const,
    label: "Warning",
    color: "bg-yellow-500",
  },
  error: {
    variant: "destructive" as const,
    label: "Error",
    color: "bg-red-500",
  },
  pending: {
    variant: "secondary" as const,
    label: "Pending",
    color: "bg-gray-400",
  },
  running: {
    variant: "outline" as const,
    label: "Running",
    color: "bg-blue-500",
  },
}

export function StatusBadge({
  status,
  label,
  animated = false,
  className,
}: StatusBadgeProps) {
  const config = statusConfig[status] || statusConfig.pending
  const displayLabel = label || config.label

  return (
    <Badge variant={config.variant} className={cn("gap-1.5", className)}>
      <span
        className={cn(
          "h-2 w-2 rounded-full",
          config.color,
          animated && status === "running" && "animate-pulse",
        )}
      />
      {displayLabel}
    </Badge>
  )
}

export default StatusBadge
